import React from "react";

function DoorTerror() {
    return (
        <div>
            <h2>Terror Threat Awareness & Counter-Terrorism</h2>
            <p>
                Door Supervisors are on the front line of public safety. This module focuses on recognizing potential terrorist threats, understanding current threat levels, and responding appropriately to suspicious activity.
            </p>

            <h3>Understanding the Threat</h3>
            <ul>
                <li>UK threat levels range from <strong>Low</strong> to <strong>Critical</strong></li>
                <li>Threats may include explosives, weapons, vehicles, or cyber attacks</li>
                <li>Targets often include crowded places, transport hubs, and public events</li>
            </ul>

            <h3>Identifying Suspicious Behavior</h3>
            <ul>
                <li>Unusual clothing or bulky items in warm weather</li>
                <li>Nervous behavior, loitering, or surveillance activity</li>
                <li>Attempts to access restricted areas</li>
                <li>Abandoned bags or vehicles</li>
            </ul>

            <h3>Action: What to Do</h3>
            <ul>
                <li>Follow the <strong>ACT: Action Counters Terrorism</strong> guidance</li>
                <li>Use the <strong>HOT</strong> protocol for unattended items:
                    <ul>
                        <li><strong>H</strong>idden?</li>
                        <li><strong>O</strong>bvious threat?</li>
                        <li><strong>T</strong>ypical for the environment?</li>
                    </ul>
                </li>
                <li>Do not touch suspicious items</li>
                <li>Evacuate and call 999 if necessary</li>
                <li>Report to police or Counter Terrorism Hotline: <strong>0800 789 321</strong></li>
            </ul>

            <h3>Working with Authorities</h3>
            <ul>
                <li>Cooperate fully with police and emergency services</li>
                <li>Provide clear, factual information</li>
                <li>Assist with crowd control and evacuation</li>
                <li>Document the incident afterward</li>
            </ul>

            <h3>ACT Awareness eLearning</h3>
            <p>
                The UK government offers free counter-terrorism training for security professionals:
                <br />
                <a href="https://www.gov.uk/government/news/act-awareness-elearning" target="_blank" rel="noreferrer">
                    ACT Awareness eLearning
                </a>
            </p>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.gov.uk/government/publications/recognising-the-terrorist-threat" target="_blank" rel="noreferrer">UK Gov – Recognising the Terrorist Threat</a></li>
                <li><a href="https://www.cpni.gov.uk/" target="_blank" rel="noreferrer">CPNI – Centre for the Protection of National Infrastructure</a></li>
                <li><a href="https://www.mi5.gov.uk/threat-levels" target="_blank" rel="noreferrer">MI5 – Current Threat Levels</a></li>
            </ul>
        </div>
    );
}

export default DoorTerror;
